import { useEffect, useState } from "react";
import UserAccTreeSelect from "../general/form-control/user-acc-tree-select";
import UserAccTreeSelect2 from "../general/form-control/user-acc-select";


const SelectInput = ({ label,id,onValueChange,onValuesChange,mode=null,singleMode=true,initialSelectFirst=true }:any) => {
    const [currentAccNo, setCurrentAccNo] = useState<any>([]);
    const [currentAccDetails, setCurrentAccDetails] = useState<any>([]);

    // useEffect(() => {
    //     onValueChange("accounts[]",currentAccNo);
    // }, [currentAccNo]);

    // useEffect(() => {
    //     onValueChange("accounts_details[]",currentAccDetails);
    // }, [currentAccDetails]);

    return (
        <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
            {' '}
            <div className="input-container ">
                <div className="label">Username / Account No </div>
                <UserAccTreeSelect
                    initialSelectFirst={initialSelectFirst}
                    mode={mode}
                    singleMode={singleMode}
                    // onChange={(value: string[]) => {
                    //     setCurrentAccNo(value);
                    // }}

                    onSelectedDetails={(values:string,selectedDetails: string) =>
                       {    
                            // setCurrentAccNo(values);
                            // setCurrentAccDetails(selectedDetails);
                            //console.log("onValueChange",values,selectedDetails)
                            if(onValuesChange){
                                onValuesChange({
                                    "accounts[]":values,
                                    "accounts_details[]":selectedDetails
                                });
                            }
                         
                       }
                    }
                />
                {/* <UserAccTreeSelect2
                    // onChange={(value: string[]) => {
                    //     setCurrentAccNo(value);
                    // }}
                /> */}
            </div>
        </div>
    );
}

export default SelectInput;